export const COMPETENCES_ASSOCIATED_SUCCESSFULLY = 'Competenze associate con successo';
